<template>
  <SidebarComponent />
  <div class="dashboard-layout">
    <div class="content-container">
      <div class="card-container">
        <div class="titolo-card">
          <h1>Programmi da oscurare</h1>
          <h3>Lista basata su data consegna programmi + 45 giorni.</h3>
        </div>

        <section class="toolbar-card card-surface">
          <div class="filters-header">
            <button
              type="button"
              class="accordion-toggle"
              @click="filtersOpen = !filtersOpen"
              :aria-expanded="filtersOpen"
            >
              <div class="toggle-copy">
                <span class="toggle-title">Filtri e azioni</span>
                <span class="toggle-subtitle">Intervallo, studio, refresh</span>
              </div>
              <span class="material-icons" aria-hidden="true">
                {{ filtersOpen ? 'expand_less' : 'expand_more' }}
              </span>
            </button>
          </div>

          <transition name="accordion">
            <div v-show="filtersOpen" class="accordion-panel">
              <div class="toolbar">
                <div class="toolbar-group toolbar-group--sm">
                  <label class="toolbar-label" for="hide-from">Dal</label>
                  <input
                    id="hide-from"
                    type="date"
                    v-model="filterFrom"
                    class="input date-range-input date-range-input--short"
                  />
                </div>
                <div class="toolbar-group toolbar-group--sm">
                  <label class="toolbar-label" for="hide-to">Al</label>
                  <input
                    id="hide-to"
                    type="date"
                    v-model="filterTo"
                    class="input date-range-input date-range-input--short"
                  />
                </div>
                <div class="toolbar-group toolbar-group--md">
                  <label class="toolbar-label" for="hide-studio">Studio</label>
                  <select id="hide-studio" v-model="studioFilter" class="input">
                    <option value="">Tutti</option>
                    <option :value="noStudioFilterValue">NO STUDIO</option>
                    <option v-for="studio in studioOptions" :key="studio" :value="studio">{{ studio }}</option>
                  </select>
                </div>

                <div class="toolbar-actions">
                  <button class="btn primary staff-button-neutral" type="button" @click="resetToDefaultRange">
                    Ieri/Oggi
                  </button>
                  <button class="btn ghost" type="button" :disabled="loading" @click="loadPrograms">
                    {{ loading ? 'Aggiorno…' : 'Aggiorna lista' }}
                  </button>
                  <button class="btn ghost" type="button" @click="showOscurati = !showOscurati">
                    {{ showOscurati ? 'Nascondi oscurati' : 'Mostra oscurati' }}
                  </button>
                  <button
                    class="btn ghost"
                    type="button"
                    :disabled="loading || bulkRunning || !selectableRows.length"
                    @click="toggleSelectAll"
                  >
                    {{ allSelectableRowsSelected ? 'Deseleziona tutti' : 'Seleziona tutti' }}
                  </button>
                  <button
                    class="btn primary"
                    type="button"
                    :disabled="bulkActionDisabled"
                    @click="runBulkAction"
                  >
                    {{ bulkActionLabel }}
                  </button>
                  <button
                    v-if="canSyncHideDates"
                    class="btn ghost"
                    type="button"
                    :disabled="syncRunning || loading"
                    @click="syncHideDates"
                  >
                    {{ syncRunning ? 'Allineo…' : 'Allinea date consegna' }}
                  </button>
                </div>
              </div>

              <div v-if="loadError" class="feedback-row">
                <span class="error">{{ loadError }}</span>
              </div>
              <div v-if="bulkStatus || bulkError" class="feedback-row">
                <span v-if="bulkStatus" class="muted">{{ bulkStatus }}</span>
                <span v-if="bulkError" class="error">{{ bulkError }}</span>
              </div>
              <div v-if="syncStatus || syncError" class="feedback-row">
                <span v-if="syncStatus" class="muted">{{ syncStatus }}</span>
                <span v-if="syncError" class="error">{{ syncError }}</span>
              </div>
            </div>
          </transition>
        </section>

        <div v-if="loading" class="loader">
          <h4>Caricamento in corso…</h4>
        </div>

        <div v-else class="dataset-summary">
          <span>Mostrando {{ filteredRows.length }} programmi</span>
          <span v-if="selectedRows.length">Selezionati {{ selectedRows.length }} programmi</span>
        </div>

        <div v-if="filteredRows.length" class="tickets">
          <table class="users-table">
            <thead>
              <tr>
                <th>Data oscuramento</th>
                <th>Data consegna</th>
                <th>Utente</th>
                <th>Email</th>
                <th>Programma</th>
                <th>Notifica 40g</th>
                <th>Oscurato</th>
                <th>Azioni</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="row in filteredRows"
                :key="row.key"
                :class="{
                  'row-pending-hide': isPendingHide(row.percorsoId),
                  'row-selected': isSelected(row.percorsoId),
                }"
              >
                <td>{{ formatDateOnly(row.hideAt) || '—' }}</td>
                <td>{{ formatDateOnly(row.deliveryAt) || '—' }}</td>
                <td>{{ row.userLabel }}</td>
                <td class="mono">{{ row.userEmail || '—' }}</td>
                <td>
                  <span
                    class="program-sequence mono"
                    :data-tooltip="buildProgramTooltip(row)"
                    :aria-label="buildProgramTooltip(row)"
                    tabindex="0"
                  >
                    #{{ row.sequenceLabel || '1/1' }}
                  </span>
                </td>
                <td>
                  <button
                    type="button"
                    class="reminder-pill"
                    :class="fortyDayReminderClass(row)"
                    :title="fortyDayReminderTooltip(row)"
                    :aria-label="fortyDayReminderTooltip(row)"
                    :disabled="!canOpenFortyDayReminder(row)"
                    @click="openFortyDayReminder(row)"
                  >
                    {{ fortyDayReminderLabel(row) }}
                  </button>
                </td>
                <td>
                  <label class="checkbox-inline">
                    <input
                      type="checkbox"
                      v-model="row.oscurato"
                      @change="saveOscurato(row)"
                    />
                    <span class="muted">{{ row.oscurato ? 'Si' : 'No' }}</span>
                  </label>
                </td>
                <td>
                  <div class="buttons-container">
                    <button
                      type="button"
                      @click="openUser(row.uid)"
                      title="Apri programmi utente"
                      aria-label="Apri programmi utente"
                    >
                      <span class="material-icons">visibility</span>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-else-if="!loading" class="empty-state muted">
          Nessun programma da oscurare nel periodo selezionato.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import {
  getFirestore,
  collection,
  getDocs,
  doc,
  query,
  orderBy,
  where,
  documentId,
  updateDoc,
  writeBatch,
  startAfter,
  limit,
  serverTimestamp,
} from 'firebase/firestore';
import SidebarComponent from '../SidebarComponent.vue';
import { stepKeyFromName } from '../../lib/percorsi.js';

const DAY_MS = 24 * 60 * 60 * 1000;
const HIDE_AFTER_DAYS = 45;
const REMINDER_FOLLOW_UP_DAYS = 40;
const HIDE_ROW_GRACE_MS = 3000;
const PAGE_SIZE = 200;
const USER_CHUNK_SIZE = 10;
const REMINDER_CHUNK_SIZE = 10;
const NO_STUDIO_FILTER = '__NO_STUDIO__';
const SYNC_PRIV_UID = 'HpMiFyBZnwX6EUf6VR9iCsHkqo82';
const SYNC_PRIV_EMAIL = 'valeriobianconi@gmail.com';
const STUDIO_OPTIONS = [
  'Tivoli Quartier generale',
  'FF Genova',
  'FF Bologna',
  'FF Bari',
  'FF Pescara',
  'FF Firenze',
  'FF Torino',
  'FF Napoli',
  'FF Milano',
  'FF Roma',
  'FF Salerno',
  'FF Cagliari',
  'FF Milano Città Studi',
  'FF Roma Eur',
  'FF Milano Sempione',
  'FF Padova'
];

const chunkList = (items, size) => {
  const out = [];
  for (let i = 0; i < items.length; i += size) {
    out.push(items.slice(i, i + size));
  }
  return out;
};

const toDateSafe = (value) => {
  if (value === undefined || value === null) return null;
  if (typeof value?.toDate === 'function') {
    try {
      const converted = value.toDate();
      return converted instanceof Date && !Number.isNaN(converted.getTime()) ? converted : null;
    } catch {
      return null;
    }
  }
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  if (typeof value === 'string' || typeof value === 'number') {
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }
  return null;
};

const toDateKey = (date) => {
  if (!date) return '';
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

const normalizeStudioName = (value) => {
  if (!value) return '';
  return value
    .toString()
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ');
};

const normalizeEmail = (value) => (value || '').toString().trim().toLowerCase();

const isConsegnaStep = (name = '') => (name || '').toLowerCase().includes('consegna');

const sameInstant = (left, right) => {
  const leftDate = toDateSafe(left);
  const rightDate = toDateSafe(right);
  if (!leftDate && !rightDate) return true;
  if (!leftDate || !rightDate) return false;
  return leftDate.getTime() === rightDate.getTime();
};

const resolveDeliveryStep = (steps = []) => {
  const list = Array.isArray(steps) ? steps : [];
  for (let idx = 0; idx < list.length; idx += 1) {
    const step = list[idx];
    if (!isConsegnaStep(step?.name)) continue;
    const doneAt = toDateSafe(step?.doneAt);
    if (!doneAt) continue;
    return { step, idx, doneAt };
  }
  return null;
};

const buildHideDatesFromSteps = (steps = []) => {
  const delivery = resolveDeliveryStep(steps);
  if (!delivery) {
    return {
      deliveryAt: null,
      hideAt: null,
    };
  }

  const deliveryAt = delivery.doneAt;
  const hideAt = new Date(deliveryAt.getTime() + HIDE_AFTER_DAYS * DAY_MS);
  if (Number.isNaN(hideAt.getTime())) {
    return {
      deliveryAt: null,
      hideAt: null,
    };
  }

  return { deliveryAt, hideAt };
};

const buildReminderDocId = (percorsoId, stepIndex) => {
  if (!percorsoId || !Number.isInteger(stepIndex) || stepIndex < 0) return '';
  return `${percorsoId}__${stepIndex}__${REMINDER_FOLLOW_UP_DAYS}`;
};

const toPositiveInt = (value) => {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? number : null;
};

const isLastProgramInSequence = (percorso = {}) => {
  const currentIndex = toPositiveInt(percorso.sequenceIndex) || 1;
  const total = toPositiveInt(percorso.sequenceTotal) || currentIndex;
  return currentIndex >= total;
};

const hasCompletedFinalCheckStep = (steps = []) => {
  const list = Array.isArray(steps) ? steps : [];
  return list.some((step) => {
    if (stepKeyFromName(step?.name) !== 'check_finale') return false;
    if (step?.convertedFromQuestionario) return false;
    return !!step?.done || !!toDateSafe(step?.doneAt);
  });
};

export default {
  name: 'ProgrammiDaOscurare',
  components: { SidebarComponent },
  setup() {
    const db = getFirestore();
    const auth = getAuth();
    const router = useRouter();

    const loading = ref(true);
    const loadError = ref('');
    const rows = ref([]);
    const filterFrom = ref('');
    const filterTo = ref('');
    const studioFilter = ref('');
    const filtersOpen = ref(true);
    const showOscurati = ref(false);
    const bulkRunning = ref(false);
    const bulkStatus = ref('');
    const bulkError = ref('');
    const syncRunning = ref(false);
    const syncStatus = ref('');
    const syncError = ref('');
    const canSyncHideDates = ref(false);
    const userCache = new Map();
    const selectedMap = ref({});
    const pendingHideMap = ref({});
    const saveQueueMap = new Map();
    const pendingHideTimers = new Map();

    const dateFormatter = new Intl.DateTimeFormat('it-IT', {
      day: '2-digit', month: '2-digit', year: 'numeric'
    });

    const formatDateOnly = (value) => {
      const date = toDateSafe(value);
      return date ? dateFormatter.format(date) : '';
    };

    const buildProgramTooltip = (row) => {
      const sequenceLabel = row?.sequenceLabel || '1/1';
      const programTitle = row?.programTitle || 'Programma';
      return `${programTitle} - Percorso ${sequenceLabel}`;
    };

    const buildExpectedFortyDayDueAt = (row) => {
      const deliveryAt = toDateSafe(row?.deliveryAt);
      if (!deliveryAt) return null;
      const dueAt = new Date(deliveryAt.getTime() + REMINDER_FOLLOW_UP_DAYS * DAY_MS);
      return Number.isNaN(dueAt.getTime()) ? null : dueAt;
    };

    const normalizeReminder = (docSnap) => {
      const data = docSnap.data() || {};
      const dueAt = toDateSafe(data.dueAt);
      const sentAt = toDateSafe(data.sentAt);
      const blockedAt = toDateSafe(data.blockedAt);
      const updatedAt = toDateSafe(data.updatedAt);
      return {
        id: docSnap.id,
        ...data,
        dueAt,
        sentAt,
        blockedAt,
        updatedAt,
        status: data.status || (sentAt ? 'sent' : ''),
      };
    };

    const fetchFortyDayReminderMap = async (sourceRows) => {
      const ids = Array.from(new Set(
        (sourceRows || [])
          .map((row) => row.fortyDayReminderId)
          .filter(Boolean)
      ));
      const reminderMap = new Map();
      if (!ids.length) return reminderMap;

      const chunks = chunkList(ids, REMINDER_CHUNK_SIZE);
      for (const chunk of chunks) {
        const remindersSnap = await getDocs(
          query(collection(db, 'ticket_reminders'), where(documentId(), 'in', chunk))
        );
        remindersSnap.forEach((docSnap) => {
          reminderMap.set(docSnap.id, normalizeReminder(docSnap));
        });
      }
      return reminderMap;
    };

    const resetToDefaultRange = () => {
      const today = new Date();
      const yesterday = new Date();
      yesterday.setDate(today.getDate() - 1);
      filterFrom.value = toDateKey(yesterday);
      filterTo.value = toDateKey(today);
    };

    const loadPrograms = async () => {
      loading.value = true;
      loadError.value = '';
      try {
        if (!filterFrom.value || !filterTo.value) {
          rows.value = [];
          return;
        }

        const fromDate = new Date(`${filterFrom.value}T00:00:00`);
        const toDate = new Date(`${filterTo.value}T23:59:59.999`);
        if (Number.isNaN(fromDate.getTime()) || Number.isNaN(toDate.getTime())) {
          rows.value = [];
          return;
        }

        const snap = await getDocs(query(
          collection(db, 'percorsi'),
          where('hideAfter45At', '>=', fromDate),
          where('hideAfter45At', '<=', toDate),
          orderBy('hideAfter45At', 'asc')
        ));

        const collectedRows = snap.docs
          .map((docSnap) => {
            const data = docSnap.data() || {};
            const deliveryStep = resolveDeliveryStep(data.steps);
            const consegnaStepIndex = Number.isInteger(deliveryStep?.idx) ? deliveryStep.idx : null;
            const deliveryAt = toDateSafe(data.deliveryDoneAt);
            const hideAt = toDateSafe(data.hideAfter45At);
            return {
              key: docSnap.id,
              percorsoId: docSnap.id,
              consegnaStepIndex,
              fortyDayReminderId: buildReminderDocId(docSnap.id, consegnaStepIndex),
              uid: data.uid || data.userUid || '',
              userEmail: data.userEmail || '',
              programTitle: data.title || data.productName || '',
              sequenceLabel: data.sequenceTotal
                ? `${data.sequenceIndex || 1}/${data.sequenceTotal}`
                : '',
              deliveryAt,
              hideAt,
              hideMs: hideAt ? hideAt.getTime() : NaN,
              oscurato: data.hideAfter45Done === true,
              userStudio: data.studio || '',
              isLastProgram: isLastProgramInSequence(data),
              hasCompletedFinalCheck: hasCompletedFinalCheckStep(data.steps),
            };
          })
          .filter((row) => (
            row.hideAt
            && row.deliveryAt
            && (!row.hasCompletedFinalCheck || row.isLastProgram)
          ));

        const uidList = Array.from(new Set(
          collectedRows
            .map((row) => row.uid)
            .filter((uid) => uid && !userCache.has(uid))
        ));
        const chunks = chunkList(uidList, USER_CHUNK_SIZE);

        const usersTask = Promise.all(chunks.map(async (chunk) => {
          const usersSnap = await getDocs(
            query(collection(db, 'users'), where(documentId(), 'in', chunk))
          );
          usersSnap.forEach((docSnap) => {
            userCache.set(docSnap.id, { uid: docSnap.id, ...docSnap.data() });
          });
        }));
        const remindersTask = fetchFortyDayReminderMap(collectedRows);
        const [, fortyDayReminderMap] = await Promise.all([usersTask, remindersTask]);

        rows.value = collectedRows
          .map((row) => {
            const user = row.uid ? userCache.get(row.uid) || {} : {};
            const userStudio = user.studio || row.userStudio || '';
            const userLabel = [user.name, user.surname].filter(Boolean).join(' ').trim()
              || user.email
              || row.userEmail
              || row.uid
              || '—';
            return {
              ...row,
              userEmail: row.userEmail || user.email || '',
              userLabel,
              userStudio,
              fortyDayReminder: row.fortyDayReminderId
                ? fortyDayReminderMap.get(row.fortyDayReminderId) || null
                : null,
              savedOscurato: row.oscurato,
            };
          })
          .sort((a, b) => a.hideMs - b.hideMs);
      } catch (error) {
        console.error('Errore caricamento programmi da oscurare:', error);
        loadError.value = 'Errore durante il caricamento. Controlla la console.';
        rows.value = [];
      } finally {
        loading.value = false;
      }
    };

    const filteredRows = computed(() => {
      return (rows.value || []).filter((row) => {
        if (!showOscurati.value && row.oscurato && !pendingHideMap.value[row.percorsoId]) return false;
        if (!studioFilter.value) return true;
        const normalized = normalizeStudioName(row.userStudio || '');
        if (studioFilter.value === NO_STUDIO_FILTER) return !normalized;
        return normalizeStudioName(studioFilter.value) === normalized;
      });
    });

    const fortyDayReminderState = (row) => {
      if (!row?.fortyDayReminderId) return 'unindexed';
      const reminder = row?.fortyDayReminder;
      if (!reminder) return 'missing';
      if (reminder.sentAt || reminder.status === 'sent') return 'sent';
      if (reminder.status === 'blocked') return 'blocked';
      if (reminder.status === 'disabled') return 'disabled';
      if (reminder.status === 'overdue') return 'overdue';
      return 'queued';
    };

    const fortyDayReminderLabel = (row) => {
      const state = fortyDayReminderState(row);
      if (state === 'sent') return 'Inviata';
      if (state === 'blocked') return 'Bloccata';
      if (state === 'disabled') return 'Off';
      if (state === 'overdue') return 'Non inviata';
      if (state === 'missing') return 'Non trovata';
      if (state === 'unindexed') return 'Indice assente';
      return 'In coda';
    };

    const fortyDayReminderClass = (row) => `reminder-pill--${fortyDayReminderState(row)}`;

    const fortyDayReminderTooltip = (row) => {
      const reminder = row?.fortyDayReminder;
      const expectedDueAt = reminder?.dueAt || buildExpectedFortyDayDueAt(row);
      const dueText = formatDateOnly(expectedDueAt) || 'data non disponibile';
      const docText = row?.fortyDayReminderId || 'documento non calcolabile';

      if (!row?.fortyDayReminderId) {
        return `Notifica 40 giorni non collegabile: step consegna non indicizzato. Data attesa: ${dueText}.`;
      }
      if (!reminder) {
        return `Reminder 40 giorni non trovato (${docText}). Data attesa: ${dueText}.`;
      }
      if (reminder.sentAt || reminder.status === 'sent') {
        return `Notifica 40 giorni inviata${reminder.sentAt ? ` il ${formatDateOnly(reminder.sentAt)}` : ''}. Data prevista: ${dueText}.`;
      }
      if (reminder.status === 'blocked') {
        return `Notifica 40 giorni bloccata${reminder.blockedAt ? ` il ${formatDateOnly(reminder.blockedAt)}` : ''}. Data prevista: ${dueText}.`;
      }
      if (reminder.status === 'disabled') {
        return `Notifica 40 giorni non inviata: notifiche disattivate. Data prevista: ${dueText}.`;
      }
      if (reminder.status === 'overdue') {
        return `Notifica 40 giorni non ancora inviata. Data prevista: ${dueText}.`;
      }
      return `Notifica 40 giorni in coda. Data prevista: ${dueText}.`;
    };

    const canOpenFortyDayReminder = (row) => !!(row?.percorsoId && (
      row?.fortyDayReminder?.dueAt || buildExpectedFortyDayDueAt(row)
    ));

    const openFortyDayReminder = (row) => {
      if (!canOpenFortyDayReminder(row)) return;
      const dueAt = row?.fortyDayReminder?.dueAt || buildExpectedFortyDayDueAt(row);
      const dueDateKey = toDateKey(dueAt);
      const route = {
        path: '/notifiche-40-giorni',
        query: {
          from: dueDateKey,
          to: dueDateKey,
          percorsoId: row.percorsoId,
        },
      };
      openInNewTab(route);
    };

    const selectableRows = computed(() => filteredRows.value);

    const selectedRows = computed(() => (
      filteredRows.value.filter((row) => selectedMap.value[row.percorsoId])
    ));

    const selectedOscuratiRows = computed(() => (
      selectedRows.value.filter((row) => row.oscurato)
    ));

    const selectedNonOscuratiRows = computed(() => (
      selectedRows.value.filter((row) => !row.oscurato)
    ));

    const bulkActionRemovesOscuramento = computed(() => showOscurati.value);

    const bulkActionDisabled = computed(() => {
      if (loading.value || bulkRunning.value) return true;
      return bulkActionRemovesOscuramento.value
        ? !selectedOscuratiRows.value.length
        : !selectedNonOscuratiRows.value.length;
    });

    const bulkActionLabel = computed(() => {
      if (bulkRunning.value) return 'Aggiorno…';
      return bulkActionRemovesOscuramento.value ? 'Elimina oscuramento' : 'Oscura tutti';
    });

    const allSelectableRowsSelected = computed(() => (
      selectableRows.value.length > 0 && selectedRows.value.length === selectableRows.value.length
    ));

    const isSelected = (percorsoId) => !!selectedMap.value[percorsoId];

    const clearSelection = () => {
      if (!Object.keys(selectedMap.value).length) return;
      selectedMap.value = {};
    };

    const toggleSelectAll = () => {
      bulkError.value = '';
      bulkStatus.value = '';
      if (allSelectableRowsSelected.value) {
        clearSelection();
        return;
      }
      const next = {};
      selectableRows.value.forEach((row) => {
        next[row.percorsoId] = true;
      });
      selectedMap.value = next;
    };

    const clearPendingHide = (percorsoId) => {
      const timerId = pendingHideTimers.get(percorsoId);
      if (timerId) {
        clearTimeout(timerId);
        pendingHideTimers.delete(percorsoId);
      }
      if (!pendingHideMap.value[percorsoId]) return;
      const next = { ...pendingHideMap.value };
      delete next[percorsoId];
      pendingHideMap.value = next;
    };

    const schedulePendingHide = (percorsoId) => {
      clearPendingHide(percorsoId);
      pendingHideMap.value = {
        ...pendingHideMap.value,
        [percorsoId]: Date.now() + HIDE_ROW_GRACE_MS,
      };
      const timerId = setTimeout(() => {
        clearPendingHide(percorsoId);
      }, HIDE_ROW_GRACE_MS);
      pendingHideTimers.set(percorsoId, timerId);
    };

    const isPendingHide = (percorsoId) => !!pendingHideMap.value[percorsoId];

    const enqueueOscuratoSave = async (row, nextValue) => {
      const percorsoId = row?.percorsoId;
      if (!percorsoId) return;

      let state = saveQueueMap.get(percorsoId);
      if (!state) {
        state = { inFlight: false, queuedValue: null };
        saveQueueMap.set(percorsoId, state);
      }

      state.queuedValue = !!nextValue;
      if (state.inFlight) return;

      state.inFlight = true;
      while (state.queuedValue !== null) {
        const valueToSave = state.queuedValue;
        state.queuedValue = null;
        if (valueToSave === !!row.savedOscurato) continue;

        try {
          await updateDoc(doc(db, 'percorsi', percorsoId), {
            hideAfter45Done: valueToSave,
            hideAfter45DoneAt: valueToSave ? serverTimestamp() : null,
          });
          row.savedOscurato = valueToSave;
        } catch (error) {
          clearPendingHide(percorsoId);
          row.oscurato = !!row.savedOscurato;
          state.queuedValue = null;
          console.error('Errore salvataggio oscurato:', error);
          break;
        }
      }

      state.inFlight = false;
      if (state.queuedValue === null) {
        saveQueueMap.delete(percorsoId);
      }
    };

    const saveOscurato = (row) => {
      if (!row?.percorsoId) return;
      const nextValue = !!row.oscurato;
      bulkError.value = '';
      bulkStatus.value = '';

      if (nextValue) {
        schedulePendingHide(row.percorsoId);
        if (selectedMap.value[row.percorsoId]) {
          const nextSelection = { ...selectedMap.value };
          delete nextSelection[row.percorsoId];
          selectedMap.value = nextSelection;
        }
      } else {
        clearPendingHide(row.percorsoId);
      }

      enqueueOscuratoSave(row, nextValue);
    };

    const commitOscuratoBatch = async (targetRows, value) => {
      let batch = writeBatch(db);
      let ops = 0;

      const flush = async () => {
        if (!ops) return;
        await batch.commit();
        batch = writeBatch(db);
        ops = 0;
      };

      for (const row of targetRows) {
        batch.update(doc(db, 'percorsi', row.percorsoId), {
          hideAfter45Done: value,
          hideAfter45DoneAt: value ? serverTimestamp() : null,
        });
        ops += 1;

        if (ops >= 400) {
          await flush();
        }
      }

      await flush();
    };

    const bulkOscuraSelected = async () => {
      const targetRows = selectedNonOscuratiRows.value;
      if (!targetRows.length || bulkRunning.value) return;

      bulkRunning.value = true;
      bulkError.value = '';
      bulkStatus.value = `Oscuramento di ${targetRows.length} programmi in corso…`;

      const previousSelection = { ...selectedMap.value };

      try {
        targetRows.forEach((row) => {
          row.oscurato = true;
          schedulePendingHide(row.percorsoId);
        });

        await commitOscuratoBatch(targetRows, true);

        targetRows.forEach((row) => {
          row.savedOscurato = true;
        });

        clearSelection();
        bulkStatus.value = `${targetRows.length} programmi oscurati.`;
      } catch (error) {
        selectedMap.value = previousSelection;
        targetRows.forEach((row) => {
          clearPendingHide(row.percorsoId);
          row.oscurato = !!row.savedOscurato;
        });
        console.error('Errore oscuramento multiplo:', error);
        bulkError.value = 'Errore durante l’oscuramento multiplo. Controlla la console.';
        bulkStatus.value = '';
      } finally {
        bulkRunning.value = false;
      }
    };

    const bulkRimuoviOscuramento = async () => {
      const targetRows = selectedOscuratiRows.value;
      if (!targetRows.length || bulkRunning.value) return;

      bulkRunning.value = true;
      bulkError.value = '';
      bulkStatus.value = `Rimozione oscuramento di ${targetRows.length} programmi in corso…`;

      const previousSelection = { ...selectedMap.value };

      try {
        targetRows.forEach((row) => {
          clearPendingHide(row.percorsoId);
          row.oscurato = false;
        });

        await commitOscuratoBatch(targetRows, false);

        targetRows.forEach((row) => {
          row.savedOscurato = false;
        });

        clearSelection();
        bulkStatus.value = `Oscuramento rimosso da ${targetRows.length} programmi.`;
      } catch (error) {
        selectedMap.value = previousSelection;
        targetRows.forEach((row) => {
          row.oscurato = !!row.savedOscurato;
        });
        console.error('Errore rimozione oscuramento multiplo:', error);
        bulkError.value = 'Errore durante la rimozione massiva dell’oscuramento. Controlla la console.';
        bulkStatus.value = '';
      } finally {
        bulkRunning.value = false;
      }
    };

    const runBulkAction = () => {
      if (bulkActionRemovesOscuramento.value) {
        return bulkRimuoviOscuramento();
      }
      return bulkOscuraSelected();
    };

    const syncHideDates = async () => {
      if (syncRunning.value) return;
      syncRunning.value = true;
      syncStatus.value = 'Allineamento date in corso…';
      syncError.value = '';
      try {
        let processed = 0;
        let updated = 0;
        let lastDoc = null;
        let hasMore = true;
        let batch = writeBatch(db);
        let ops = 0;

        const flush = async () => {
          if (!ops) return;
          await batch.commit();
          batch = writeBatch(db);
          ops = 0;
        };

        while (hasMore) {
          const constraints = [orderBy(documentId()), limit(PAGE_SIZE)];
          if (lastDoc) constraints.splice(1, 0, startAfter(lastDoc));
          const snap = await getDocs(query(collection(db, 'percorsi'), ...constraints));
          if (snap.empty) {
            hasMore = false;
            continue;
          }

          snap.docs.forEach((docSnap) => {
            processed += 1;
            const data = docSnap.data() || {};
            const nextDates = buildHideDatesFromSteps(data.steps);
            const currentDelivery = toDateSafe(data.deliveryDoneAt);
            const currentHide = toDateSafe(data.hideAfter45At);

            if (
              sameInstant(currentDelivery, nextDates.deliveryAt)
              && sameInstant(currentHide, nextDates.hideAt)
            ) {
              return;
            }

            batch.update(docSnap.ref, {
              deliveryDoneAt: nextDates.deliveryAt,
              hideAfter45At: nextDates.hideAt,
            });
            ops += 1;
            updated += 1;
          });

          if (ops >= 400) {
            await flush();
          }

          if (snap.docs.length < PAGE_SIZE) {
            hasMore = false;
          } else {
            lastDoc = snap.docs[snap.docs.length - 1];
          }
        }

        await flush();
        syncStatus.value = `Allineamento completato. Percorsi controllati: ${processed}. Aggiornati: ${updated}.`;
        await loadPrograms();
      } catch (error) {
        console.error('Errore allineamento date oscuramento:', error);
        syncError.value = 'Errore durante l’allineamento. Controlla la console.';
        syncStatus.value = '';
      } finally {
        syncRunning.value = false;
      }
    };

    const openInNewTab = (route) => {
      const resolved = router.resolve(route);
      window.open(resolved.href, '_blank', 'noopener');
    };

    const openUser = (uid) => {
      if (!uid) return;
      const route = { name: 'UserProgrammi', params: { userId: uid } };
      const resolved = router.resolve(route);
      const pendingTab = window.open('about:blank', '_blank');
      if (pendingTab) {
        pendingTab.opener = null;
        pendingTab.location.href = resolved.href;
      } else {
        openInNewTab(route);
      }
    };

    const updateSyncPermission = (user) => {
      const email = normalizeEmail(user?.email);
      canSyncHideDates.value = !!user
        && user.uid === SYNC_PRIV_UID
        && email === SYNC_PRIV_EMAIL;
    };

    let authUnsubscribe = null;

    onMounted(() => {
      updateSyncPermission(auth.currentUser);
      authUnsubscribe = onAuthStateChanged(auth, updateSyncPermission);
      resetToDefaultRange();
      loadPrograms();
    });

    onUnmounted(() => {
      if (typeof authUnsubscribe === 'function') authUnsubscribe();
      pendingHideTimers.forEach((timerId) => clearTimeout(timerId));
      pendingHideTimers.clear();
      saveQueueMap.clear();
    });

    return {
      loading,
      loadError,
      filterFrom,
      filterTo,
      studioFilter,
      filtersOpen,
      showOscurati,
      bulkRunning,
      bulkStatus,
      bulkError,
      bulkActionDisabled,
      bulkActionLabel,
      canSyncHideDates,
      filteredRows,
      selectableRows,
      selectedRows,
      allSelectableRowsSelected,
      formatDateOnly,
      buildProgramTooltip,
      fortyDayReminderLabel,
      fortyDayReminderClass,
      fortyDayReminderTooltip,
      canOpenFortyDayReminder,
      openFortyDayReminder,
      resetToDefaultRange,
      loadPrograms,
      toggleSelectAll,
      runBulkAction,
      syncRunning,
      syncStatus,
      syncError,
      syncHideDates,
      saveOscurato,
      openUser,
      isSelected,
      isPendingHide,
      studioOptions: STUDIO_OPTIONS,
      noStudioFilterValue: NO_STUDIO_FILTER,
    };
  }
};
</script>

<style scoped>
.dataset-summary {
  margin: 8px 0 12px;
  display: flex;
  gap: 12px;
  font-size: 0.9rem;
  color: #475569;
}

.row-pending-hide {
  background: #f1f5f9;
  transition: background 0.18s ease, color 0.18s ease;
}

.row-pending-hide td {
  color: #64748b;
}

.row-selected:not(.row-pending-hide) {
  background: #eff6ff;
}

.row-selected:not(.row-pending-hide) td {
  color: #1e3a8a;
}

.program-sequence {
  position: relative;
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 999px;
  background: #e2e8f0;
  color: #0f172a;
  font-weight: 700;
  cursor: help;
  outline: none;
}

.program-sequence::after {
  content: attr(data-tooltip);
  position: absolute;
  left: 50%;
  bottom: calc(100% + 10px);
  transform: translateX(-50%) translateY(4px);
  width: 220px;
  padding: 8px 10px;
  border-radius: 10px;
  background: #0f172a;
  color: #f8fafc;
  font-size: 0.78rem;
  font-weight: 600;
  line-height: 1.3;
  white-space: normal;
  text-align: left;
  overflow-wrap: anywhere;
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.22);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.16s ease, transform 0.16s ease, visibility 0.16s ease;
  z-index: 20;
}

.program-sequence::before {
  content: '';
  position: absolute;
  left: 50%;
  bottom: calc(100% + 4px);
  transform: translateX(-50%) translateY(4px);
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #0f172a;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.16s ease, transform 0.16s ease, visibility 0.16s ease;
  z-index: 20;
}

.program-sequence:hover::after,
.program-sequence:hover::before,
.program-sequence:focus-visible::after,
.program-sequence:focus-visible::before {
  opacity: 1;
  visibility: visible;
  transform: translateX(-50%) translateY(0);
}

.reminder-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 96px;
  padding: 5px 10px;
  border-radius: 999px;
  border: 1px solid transparent;
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1.2;
  cursor: pointer;
  transition: transform 0.16s ease, box-shadow 0.16s ease, border-color 0.16s ease;
}

.reminder-pill:hover:not(:disabled),
.reminder-pill:focus-visible:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.12);
  outline: none;
}

.reminder-pill:disabled {
  cursor: default;
}

.reminder-pill--sent {
  background: #dcfce7;
  color: #166534;
  border-color: #86efac;
}

.reminder-pill--queued {
  background: #fef3c7;
  color: #92400e;
  border-color: #fde68a;
}

.reminder-pill--overdue,
.reminder-pill--missing {
  background: #fee2e2;
  color: #b91c1c;
  border-color: #fecaca;
}

.reminder-pill--blocked {
  background: #ede9fe;
  color: #6b21a8;
  border-color: #ddd6fe;
}

.reminder-pill--disabled,
.reminder-pill--unindexed {
  background: #f1f5f9;
  color: #475569;
  border-color: #cbd5e1;
}

.card-surface {
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.08);
  padding: 18px 20px;
  margin-top: 18px;
}

.toolbar-card {
  margin-top: 24px;
}

.filters-header {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.accordion-toggle {
  flex: 1 1 320px;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #0f172a;
  cursor: pointer;
  transition: border 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

.accordion-toggle:hover {
  background: #fff;
  border-color: #cbd5e1;
  box-shadow: 0 12px 26px rgba(15, 23, 42, 0.08);
}

.accordion-toggle .material-icons {
  font-size: 22px;
  color: #475569;
}

.toggle-copy {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}

.toggle-title {
  font-weight: 700;
  font-size: 0.95rem;
}

.toggle-subtitle {
  font-size: 0.82rem;
  color: #64748b;
}

.accordion-panel {
  margin-top: 14px;
  padding: 14px 12px;
  border-radius: 14px;
  border: 1px solid #f1f5f9;
  background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.6);
}

.accordion-enter-active,
.accordion-leave-active {
  transition: all 0.18s ease;
}

.accordion-enter,
.accordion-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

.toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: flex-end;
}

.toolbar-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 0 0 auto;
}

.toolbar-group--md { width: 200px; }
.toolbar-group--sm { width: 160px; }

.toolbar-actions {
  display: flex;
  gap: 12px;
  flex: 0 0 auto;
  align-items: center;
}

.toolbar-label {
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #64748b;
}

.date-range-input {
  width: 100%;
}

.date-range-input--short {
  width: 82% !important;
}

.input {
  width: 100%;
  padding: 10px 14px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #0f172a;
  transition: border 0.2s ease, box-shadow 0.2s ease;
}

.input:focus {
  border-color: #2563eb;
  background: #fff;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.15);
  outline: none;
}

.btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  border-radius: 12px;
  border: 1px solid transparent;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
  background: #f1f5f9;
  color: #1e293b;
  border-color: #e2e8f0;
}

.btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.12);
}

.btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  box-shadow: none;
}

.btn.primary {
  background: linear-gradient(135deg, #2563eb, #4f46e5);
  color: #fff;
}

.btn.ghost {
  background: #f1f5f9;
  color: #1e293b;
  border-color: #e2e8f0;
}

.feedback-row {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  font-size: 0.85rem;
}

.tickets {
  overflow-x: auto;
}

.users-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
}

.users-table th,
.users-table td {
  padding: 12px 10px;
  border-bottom: 1px solid #e2e8f0;
  text-align: left;
  vertical-align: middle;
}

.users-table th {
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
}

.checkbox-inline {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.checkbox-inline input[type="checkbox"] {
  width: 18px;
  height: 18px;
  accent-color: #2563eb;
}

.buttons-container {
  display: flex;
  gap: 8px;
}

.buttons-container button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: 1px solid #dbeafe;
  background: #eff6ff;
  color: #2563eb;
  cursor: pointer;
}

.buttons-container button:hover {
  background: #dbeafe;
}

.mono {
  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, monospace;
}

.muted {
  color: #64748b;
}

.error {
  color: #b91c1c;
}

.empty-state {
  margin-top: 16px;
}
</style>
